import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/_app/runs/")({
  validateSearch: z.object({
    q: z
      .string()
      .optional()
      .transform((val) => val || undefined),
    testType: z
      .array(z.enum(["SEROLOGY", "CLINICAL", "HLA", "MICROBIOLOGY"]))
      .optional()
      .transform((val) => val || undefined),
    testSpec: z
      .array(z.number())
      .optional()
      .transform((val) => val || undefined),
    labs: z
      .array(z.number())
      .optional()
      .transform((val) => val || undefined),
  }),
});
